import PortalClienteDBService from "./bases/PortalClienteDBService";

class ConsultoresService extends PortalClienteDBService{
    async ChecarCodigoConsultor(codigo){
        const url = `portaldb/Consultores/ChecarCodigoConsultor?codigoConsultor=${codigo}`;  
        return await this.get(url)
    }
}

export default new ConsultoresService();